/* eslint-disable react/no-array-index-key */
import React from 'react';
import { ClausesItem } from 'store/modules/contract_analysis/types';

interface MissingClausesProps {
  clauses: ClausesItem[] | undefined;
}

const MissingClauses = ({ clauses }: MissingClausesProps) => {
  if (!clauses || clauses.length === 0) {
    return (
      <div className="alert alert-light border d-flex align-items-center">
        <i className="material-icons text-warning mr-2">warning</i>
        <strong>Cláusulas Obrigatórias Não Identificadas</strong>
      </div>
    );
  }

  return (
    <div className="alert alert-light border">
      <div className="d-flex align-items-center mb-2">
        <i className="material-icons text-warning mr-2">warning</i>
        <strong>Cláusulas Obrigatórias Não Identificadas</strong>
      </div>
      <ul className="mb-0 pl-4">
        {clauses.map((clause, index) => (
          <li key={index} className="mb-1">
            {clause?.descricao}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default MissingClauses;
